import {
  CreateItemDocument,
  CreateItemMutation,
  CreateItemMutationVariables,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { ValidationError } from 'modules/core/lib/errors'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export type DueDateInformation = {
  offsetAmount: number | null
  offsetDirection: string | null
  referenceFieldKey: string | null
}

type CreateItemResult = NonNullable<
  CreateItemMutation['processesMutations']['createProcessesItem']['item']
>

export const useCreateItem = () => {
  const [executeMutation] = useMutation(CreateItemDocument, {
    extractorFn: (data: CreateItemMutation) => data.processesMutations.createProcessesItem,
  })

  const createItem = async (variables: CreateItemMutationVariables, processId: number) => {
    const rawResult = await executeMutation({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    const result = handleResult(rawResult, (errors) => {
      return app.setFlash({
        type: 'wrong',
        message: errors.messages || i18n.t('common.save_error'),
      })
    })

    if (!result.success)
      throw new ValidationError({ errors: i18n.t('processes.process_settings.save_error') })

    return result.success ? (result.data.item as CreateItemResult) : undefined
  }

  return {
    createItem,
  }
}
